import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import Header from "./Header/index";
import Sidebar from "./Sidebar";
import Utils from "../../../lib/utils";

import {
  getJob as getJobAction,
  applyJob as applyJobAction,
  searchJobs as searchJobsAction,
} from "../../../redux/middleware/job";
import { getUserByToken } from "../../../redux/middleware/user";

import Loader from "../../Shared/Loader";
import ProfileModal from "./ProfileModal";
import JobDescription from "./JobDescription";
import { styles } from "./style.ts";

class Job extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profileType: "0",
      openModel: false,
      borderColor: "",
      applied: false,
    };
  }

  componentDidMount = () => {
    window.scrollTo(0, 0);
    const {
      getJob,
      jobs,
      searchJobs,
      getUserByToken: getUserByTokenAction,
      match,
    } = this.props;
    const { slug } = match.params;
    getJob(slug);
    !jobs.length && searchJobs();
    getUserByTokenAction(Utils.getUserToken());
  };

  componentWillReceiveProps = (nextProps) => {
    window.scrollTo(0, 0);
    const { applyJobPending, notify } = this.props;
    if (!nextProps.applyJobPending && applyJobPending) {
      notify("success", "You successfully applied");
      this.setState({
        applied: true,
      });
    }
  };

  trim = (message, maxLength) => {
    if (message.length > maxLength) {
      let trimmedString = message && message.substr(0, maxLength);
      trimmedString = trimmedString.substr(
        0,
        Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))
      );
      trimmedString += "...";
      return trimmedString;
    }
    return message;
  };

  handleChange = (e) => {
    this.setState({
      profileType: e.target.value,
    });
  };

  handleApply = () => {
    this.setState({
      openModel: true,
      borderColor: "",
    });
  };

  handleApplyJob = (type) => {
    const { profileType } = this.state;
    const { applyJob } = this.props;
    const { user, job } = this.props;

    if (profileType !== "0") {
      this.setState({ borderColor: "" });
      if (type === "open") {
        applyJob(user, profileType, job);
        this.setState({ openModel: false });
      }
    } else {
      this.setState({ borderColor: "#a94442" });
    }

    if (type !== "open") this.setState({ openModel: false });
  };

  address = (job) => {
    if (!job.city) return job.state;
    return job.city && `${job.city}, ${job.state}`;
  };

  apply = () => {
    const { history } = this.props;
    if (Utils.isSignedIn()) {
      this.handleApply();
    } else {
      history.push(`/login`);
    }
  };

  render() {
    const {
      user,
      job,
      history,
      jobs,
      pending,
      applyJobPending,
      jobSearchPending,
    } = this.props;
    if (!job || pending || applyJobPending) return <Loader fullScreen show />;
    const { profileType, borderColor, openModel, applied } = this.state;
    const title = job.title || "Welcome to QuirkyCoders";
    document.title = `${title} | Where Developers and Employers connect!`;

    return (
      <div className="container">
        <Header
          user={user}
          history={history}
          job={job}
          trim={this.trim}
          address={this.address}
          handleApply={this.apply}
          applied={applied}
        />
        <div className="row" style={styles.container}>
          <div className="col-md-9">
            <JobDescription
              handleApply={this.handleApply}
              applied={applied}
              history={history}
              user={user}
              job={job}
            />
          </div>
          <div className="col-md-3">
            <Sidebar
              jobs={jobs}
              address={this.address}
              pending={jobSearchPending}
            />
          </div>
        </div>
        <ProfileModal
          handleChange={this.handleChange}
          user={user}
          show={openModel}
          profileType={profileType}
          borderColor={borderColor}
          handleApplyJob={this.handleApplyJob}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  job: state.job.job,
  applyJob: state.applyJob.job,
  applyJobPending: state.applyJob.pending,
  pending: state.job.pending,
  jobs: state.searchJobs.jobs,
  jobSearchPending: state.searchJobs.pending,
  user: state.userByToken.user,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getJob: getJobAction,
      applyJob: applyJobAction,
      searchJobs: searchJobsAction,
      getUserByToken,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Job);
